import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";
import { Introduction } from "./Introduction/Introduction";
export interface ManualWelcomePage {
  id: number;
  field_introduction_manual_header: string;
  field_malay_introduction_manual: string;
  field_mandarin_introduction_manu: string;
  field_manual_welcome_sub_text: string;
  field_malay_manual_welcome_sub_t: string;
  field_mandarin_manu_welc_sub_tex: string;
  field_manual_welcome_description: string;
  field_malay_manual_welcome_descr: string;
  field_mandarin_manual_welcom_des: string;
  field_manual_welcom_continue: string;
  field_malay_manual_continue_text: string;
  field_mandarin_manual_continue: string;
  field_magp_image: string;
  published: boolean;
  createdAt: boolean | string;
  updatedAt: boolean | string;
}

export interface ProcurementPlanning {
  id: number;
  field_procure_planning_parent_id: number;
  field_procurement_toggle_referen: number;
  title: string;
  field_procurement_description_en: string;
  field_procurement_description_ms: string;
  field_procurement_description_zh: string;
  field_procurement_video_url: string;
  field_procure_details_web_image: string;
  field_procurement_web_flowchart: string;
  published: boolean;
  field_procure_details_created_at: string;
  field_procure_details_updated_at: string;
}

export interface Requisition {
  id: number;
  field_requisition_list_parent_id: number;
  field_requisition_toggle_referen: number;
  field_requisition_desc_en: string;
  field_requisition_desc_ms: string;
  field_requisition_desc_zh: string;
  field_requisition_video_url: string;
  field_requisit_details_web_image: string;
  field_requisition_web_flowchart: string;
  published: boolean;
  field_requisition_det_created_at: string;
  field_requisition_det_updated_at: string;
}

export interface ContractAdministration {
  id: number;
  title: string;
  field_contract_list_parent_id: number;
  field_contract_admin_toggle_refe: number;
  field_contract_admin_toggle_refe_1: string;
  field_contract_list_parent_id_1: string;
  field_contract_admin_desc_en: string;
  field_contract_admin_desc_ms: string;
  field_contract_admin_desc_zh: string;
  field_contract_video_url: string;
  field_contract_details_web_image: string;
  field_contract_web_flowchart_img: string;
  published: boolean;
  field_contract_detail_created_at: string;
  field_contract_detail_updated_at: string;
}

export interface RequisitionProcessFlowChart {
  id: number;
  listId: number;
  toggleId: number;
  seqNumber: number;
  title: string;
  field_req_process_title_ms: string;
  field_req_process_title_zh: string;
  field_requi_flow_chart_desc_en: string;
  field_requi_flow_chart_desc_ms: string;
  field_requi_flow_chart_desc_zh: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ContractAdministrationProcessFlowChart {
  id: number;
  listId: number;
  toggleId: number;
  seqNumber: number;
  title: string;
  field_contract_process_title_ms: string;
  field_contract_process_title_zh: string;
  field_contract_flow_chart_des_en: string;
  field_contract_flow_chart_des_ms: string;
  field_contract_flow_chart_des_zh: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProcurementPlanningForProcessFlowChart {
  id: string;
  field_procurement_plan_list_refe: string;
  field_procurement_toggle_ref: string;
  field_procurement_sequence_numbe: number;
  title: string;
  field_procure_process_title_ms: string;
  field_procure_process_title_zh: string;
  field_procure_flow_chart_des_en: string;
  field_procure_flow_chart_des_ms: string;
  field_procure_flow_chart_des_zh: string;
  published: boolean;
  field_procure_flow_chart_created: string;
  field_procure_flow_chart_updated: string;
}

export interface VendorManagement {
  id: number;
  title: string;
  field_vendor_list_parent_id: number;
  field_vendor_manage_toggle_refer: number;
  field_vendor_manage_toggle_refer_1: string;
  field_vendor_list_parent_id_1: string;
  field_vendor_management_desc_en: string;
  field_vendor_management_desc_ms: string;
  field_vendor_management_desc_zh: string;
  field_vendor_video_url: string;
  field_vendor_details_web_image: string;
  field_vendor_web_flowchart_image: string;
  published: boolean;
  field_vendor_details_created_at: string;
  field_vendor_details_updated_at: string;
}

export interface VendorManagementProcessFlowChart {
  id: number;
  listId: number;
  toggleId: number;
  seqNumber: number;
  title: string;
  field_vendor_process_title_ms: string;
  field_vendor_process_title_zh: string;
  field_vendor_flow_chart_desc_en: string;
  field_vendor_flow_chart_desc_ms: string;
  field_vendor_flow_chart_desc_zh: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Sourcing {
  id: number;
  title: string;
  field_sourcing_list_parent_id: number;
  field_sourcing_toggle_reference: number;
  field_sourcing_toggle_reference_1: string;
  field_sourcing_list_parent_id_1: string;
  field_sourcing_desc_en: string;
  field_sourcing_desc_ms: string;
  field_sourcing_desc_zh: string;
  field_sourcing_video_url: string;
  field_sourcing_details_web_image: string;
  field_sourcing_web_flowchart_img: string;
  published: boolean;
  field_sourcing_detail_created_at: string;
  field_sourcing_detail_updated_at: string;
}

export interface SourcingProcessFlowChart {
  id: number;
  listId: number;
  toggleId: number;
  seqNumber: number;
  title: string;
  field_sourcing_process_title_ms: string;
  field_sourcing_process_title_zh: string;
  field_sourcing_flow_chart_des_en: string;
  field_sourcing_flow_chart_des_ms: string;
  field_sourcing_flow_chart_des_zh: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Introduction {
  id: number;
  title: string;
  field_introduction_list_referenc: number;
  field_introduction_toggle_refere: number;
  field_introduction_description: string;
  field_intro_description_malay: string;
  field_intro_description_mandarin: string;
  field_video_url: string;
  field_intro_details_web_image: string;
  published: boolean;
  field_created_at: string;
  field_updated_at: string;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await magpCMSApi.get<T>(url);
  return response.data;
};

export const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooksForIntroduction =
  <T>(key: string, getUrl: (listId: string) => string) =>
  (
    listId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

export const createDataHooks =
  <T>(key: string, getUrl: (listId: string, toggleId: string) => string) =>
  (
    listId: string,
    toggleId: string,
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key, listId, toggleId],
        enabled: false,
        queryFn: () => fetchData<T>(getUrl(listId, toggleId)),
        refetchOnWindowFocus: false,
        ...options,
      },
      queryClient
    );
  };

const useManualWelcomePage = createDataHook<ManualWelcomePage[]>("manualWelcomePage", `/api/manual-welcome/all-fields`);

const useProcurementPlanning = createDataHooks<ProcurementPlanning[]>("procurementPlanning", (listId, toggleId) => {
  {
    if (listId === null || toggleId === undefined) {
      return;
    }
    return `/api/procurement-planning-details/all-fields?listId=${listId}&toggleId=${toggleId}`;
  }
});

const useRequisition = createDataHooks<Requisition[]>("requisition", (listId, toggleId) => {
  if (listId === null || toggleId === undefined) {
    return;
  }
  return `/api/requisition-details/all-fields?listId=${listId}&toggleId=${toggleId}`;
});

const useContractAdministration = createDataHooks<ContractAdministration[]>(
  "contractAdministration",
  (listId, toggleId) => {
    if (listId === null || toggleId === undefined) {
      return;
    }
    return `/api/contract-administration-details/all-fields?listId=${listId}&toggleId=${toggleId}`;
  }
);

const useVendorManagement = createDataHooks<VendorManagement[]>("vendorManagement", (listId, toggleId) => {
  if (listId === null || toggleId === undefined) {
    return;
  }
  return `/api/vendor-management-details/all-fields?listId=${listId}&toggleId=${toggleId}`;
});

const useSourcing = createDataHooks<Sourcing[]>("sourcing", (listId, toggleId) => {
  if (listId === null || toggleId === undefined) {
    return;
  }
  return `/api/sourcing-details/all-fields?listId=${listId}&toggleId=${toggleId}`;
});

const useIntroduction = createDataHooksForIntroduction<Introduction[]>(
  "introduction",
  (listId) => `/api/introduction-details/all-fields?id=${listId}`
);

const useProcurementPlanningProcessFlowChart = createDataHooksForIntroduction<ProcurementPlanningForProcessFlowChart[]>(
  "procurementPlanningProcessFlowChart",
  (id: string) => {
    if (id === null || id === undefined) {
      return;
    }
    return `/api/get-procurement-planning-process-flow-chart/all-fields?id=${id}`;
  }
);

const useRequisitionProcessFlowChart = createDataHooksForIntroduction<RequisitionProcessFlowChart[]>(
  `requisitionProcessFlowChart`,
  (id: string) => {
    if (id === null || id === undefined) {
      return;
    }
    return `/api/get-requisition-process-flow-chart/all-fields?id=${id}`;
  }
);

const useSourcingProcessFlowChart = createDataHooksForIntroduction<SourcingProcessFlowChart[]>(
  `sourcingProcessFlowChart`,
  (id: string) => {
    if (id === null || id === undefined) {
      return;
    }
    return `/api/get-sourcing-process-flow-chart/all-fields?id=${id}`;
  }
);

const useContractAdministrationProcessFlowChart = createDataHooksForIntroduction<
  ContractAdministrationProcessFlowChart[]
>(`contractAdministrationProcessFlowChart`, (id: string) => {
  if (id === null || id === undefined) {
    return;
  }
  return `/api/get-contract-process-flow-chart/all-fields?id=${id}`;
});

const useVendorManagementProcessFlowChart = createDataHooksForIntroduction<VendorManagementProcessFlowChart[]>(
  `vendorManagementProcessFlowChart`,
  (id: string) => {
    if (id === null || id === undefined) {
      return;
    }
    return `/api/get-vendor-process-flow-chart/all-fields?id=${id}`;
  }
);

export {
  useContractAdministration,
  useContractAdministrationProcessFlowChart,
  useIntroduction,
  useManualWelcomePage,
  useProcurementPlanning,
  useProcurementPlanningProcessFlowChart,
  useRequisition,
  useRequisitionProcessFlowChart,
  useSourcing,
  useSourcingProcessFlowChart,
  useVendorManagement,
  useVendorManagementProcessFlowChart,
};
